import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Landing = () => {
  const { user } = useAuth();
  return (
    <div className="container" style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.2em', color: 'var(--ink-soft)', marginBottom: '1rem' }}>
          A modern learning platform
        </div>
        <h1 style={{ fontSize: '4rem',  color: 'var(--green)' , lineHeight: 1.05 }}>
          Learn from experts.<br />
          <span style={{ fontStyle: 'italic', color: 'var(--accent)' }}>Earn what counts.</span>
        </h1>
        <p style={{ fontSize: '1.2rem', color: 'var(--ink-soft)', marginTop: '1.5rem', maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}>
          HillBoat Study brings together students, expert trainers, and admin teams into one streamlined learning experience.
        </p>
        <div className="flex gap-2 mt-3" style={{ justifyContent: 'center' }}>
          {user ? (
            <Link to={user.role === 'admin' ? '/admin' : user.role === 'trainer' ? '/trainer' : '/dashboard'} className="btn btn-primary">
              Go to dashboard →
            </Link>
          ) : (
            <>
              <Link to="/register" className="btn btn-primary">Get started free →</Link>
              <Link to="/login" className="btn btn-secondary">Sign in</Link>
            </>
          )}
        </div>
      </div>

      <div className="grid grid-3 mt-3" style={{ marginTop: '5rem' }}>
        <div className="card">
          <div style={{ fontSize: '2rem' }}>📚</div>
          <h3 className="mt-2">Curated Courses</h3>
          <p className="text-muted mt-1">Modular lessons, hands-on practice, and trainer-led guidance.</p>
        </div>
        <div className="card">
          <div style={{ fontSize: '2rem' }}>📈</div>
          <h3 className="mt-2">Track Progress</h3>
          <p className="text-muted mt-1">See your completion percentage and quiz performance in real time.</p>
        </div>
        <div className="card">
          <div style={{ fontSize: '2rem' }}>🏆</div>
          <h3 className="mt-2">Earn Certificates</h3>
          <p className="text-muted mt-1">Verifiable, shareable certificates issued by your trainer.</p>
        </div>
      </div>
    </div>
  );
};

export default Landing;
